// Copyright (c) Microsoft. All rights reserved.

export interface UsersState {
    // users: Users;
    user: UserData;
}

export const initialState: UsersState = {
    // users: {},
    user: {
        userId: '',
        exp: 0,
    },
};

export type Users = Record<string, UserData>;

export interface UserData {
    userId: string;
    name?: string;
    displayName?: string;
    deptName?: string;
    deptCode?: string;
    companyCode?: string;
    positionName?: string;
    positionId? : string;
    titleName?: string;
    role?: string;
    email?: string;
    exp: number;
    profileUrl?: string;
    levelName? : string;
}

export interface SSOUser {
    token: string
}

export interface UserSetting{
    userPrompt: UserPrompt
}

export interface UserPrompt{
    nickName?: string;
    useJob?: boolean;
    useUserUsagePattern?: boolean;
    prompt?: string;
}